export default __webpack_public_path__ + "static/media/i238hk.24ce88dd.webp";